import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SessionService, HttpService, MessageService, FunctionsService, TableColumns, TableConfiguration, CombosConfiguration, params, LocalStorageService } from 'brainloper-ui';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import { User } from 'src/app/models/administration/user';
import { Permissions } from 'src/app/models/human-resources/permissions';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { CalculateDurationService } from 'src/app/utils/calculate-duration';
import { BaseResponse } from 'src/app/models/commos/base-response';
import { GenericResponse } from 'src/app/models/commos/generic-response';
import { SizePicture } from 'src/app/models/commos/size-pircture';

@Component({
    selector: 'app-permissions-detail',
    templateUrl: './permissions-detail.component.html',
    styleUrls: ['./permissions-detail.component.scss'],
    standalone: false
})
export class PermissionsDetailComponent implements OnInit {

  private urlGetDatosUsuarios: string = `${EndpointDictionary.User.USER_COMBO}`
  public urlGetUsuarios: string = `${EndpointDictionary.User.USER_TABLE}`
  private urlGetUsuariosDetalle: string = `${EndpointDictionary.User.CRUD_USER_DATA}`
  private urlPostPermisos: string = `${EndpointDictionary.Permit.CRUD_PERMIT_DATA}`
  private messagErrorDate = "La fecha final no puede ser inferior a la fecha de inicio"
  public tipoRedireccion: string
  public imageSrc: string
  public movil: boolean
  public sizePicture: SizePicture
  public companyId:number
  public nombreSelecionado: string

  public cedula: number
  public usuario: number;
  public fechaLabel
  public duracion: string
  public inicio: string
  public final: string
  public descripcionLabel: string
  public remuneracionLabel
  public aprobadoLabel

  public firtsForm: UntypedFormGroup;
  public FormPermisos: UntypedFormGroup;

  //tabla Usuarios
  //recargarTablaUsuarios = new EventEmitter<any>()
  public configurationUsuarios: TableConfiguration = {
    edit: false,
    add: false,
    delete: false,
    selectable: false,
    primaryKey: 'userId'
  }

  public columnasUsuarios: TableColumns<User>[] = [
    {
      ID: 'user',
      label: 'Usuario',
      type: 'number',
      style: {
        textAlign: 'center',
        movil: 'no-movil'
      },

    },
    {
      ID: 'name',
      label: 'Nombre',
      type: 'string',
      style: {
        textAlign: 'center'
      },
    }
  ]

  public combosConfigResponsable: CombosConfiguration = {
    visibleField: 'name',
    selectionField: 'userId',
    urlCombo: this.urlGetDatosUsuarios,
    urlParams: [],
    label: 'Responsable',
  }

  constructor(
    public dialogRef: MatDialogRef<PermissionsDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private session: SessionService,
    private formBuilder: UntypedFormBuilder,
    private http: HttpService,
    private message: MessageService,
    private functionEter: FunctionsService,
    private calculeDuration: CalculateDurationService,
    private storage: LocalStorageService
  ) {
    this.companyId = this.storage.get<number>('companyId')
    this.firtsForm = this.formBuilder.group({
      selecion: ''
    })

    this.FormPermisos = this.formBuilder.group({
      date: '',
      startDate: '',
      finalDate: '',
      duration: '',
      description: '',
      remuneration: '',
      approvedBy: ''
    })

  }

  ngOnInit(): void {

    this.message.openLoading('Cargando', 'Cargando')
    this.tipoRedireccion = this.session.getData('redireccion')
    this.movil = screen.width > 600 ? false : true
    this.FormPermisos.get('date').setValue(new Date())

    this.sizePicture = {
      'width': `60%`,
      'margin-top': '5%',
      'border': '1px solid black',
    }

    if (this.tipoRedireccion == 'visualizar') {
      this.inicializarCampos()
    }
    if (this.tipoRedireccion == 'nuevo') {
      this.message.closeLoading()
    }
  }

  async inicializarCampos() {

    //console.log(this.data)

    let res: Array<Permissions> = await this.http.getDataBody(`${this.urlPostPermisos}/${this.data.id}`)
    if (res) {
      var data = res[0]
      this.nombreSelecionado = data.userName
      this.usuario = data.user
      this.descripcionLabel = data.description
      this.fechaLabel = this.functionEter.dateIso(data.date)
      this.inicio = this.functionEter.dateIso(data.startDate)
      this.final = this.functionEter.dateIso(data.finalDate)
      this.duracion = data.duration
      this.remuneracionLabel = data.remuneration == 1 ? 'SI' : 'NO'
      this.aprobadoLabel = data.approvedByName
    }

    let response: Array<User> = await this.http.getDataBody(`${this.urlGetUsuariosDetalle}/${data.userId}`)
    if (response) {
      let body = response[0]
      this.imageSrc = `${EndpointDictionary.Base._BASE_URL_V2}${body.photo}/${this.companyId}`
    }
    this.message.closeLoading()
  }

  async clickFilaUsuarios($event: User) {
    //console.log($event)
    this.nombreSelecionado = $event.name
    this.cedula = $event.userId
    this.usuario = $event.user
    this.firtsForm.get('selecion').setValue($event.name)
    let res: Array<User> = await this.http.getDataBody(`${this.urlGetUsuariosDetalle}/${$event.userId}`)
    if (res) {
    this.imageSrc = `${EndpointDictionary.Base._BASE_URL_V2}${res[0].photo}/${this.companyId}`}

  }

  ValueResponsable($event: User) {
    this.aprobadoLabel = $event.name
    //console.log("valueResponsable", $event)
  }

  async changeDate($event: MatDatepickerInputEvent<Date>, data: string) {
    const fechaFormateada = this.functionEter.dateForm($event.value);

    if (data == 'inicio') {
      this.inicio = fechaFormateada;
    } else {
      this.final = fechaFormateada;
    }

    if (this.inicio && this.final) {
      let inicioDate = new Date(this.inicio);
      let finalDate = new Date(this.final);


      if (finalDate >= inicioDate) {
        this.duracion = await this.calculeDuration.calculateDuration(inicioDate, finalDate)
        this.FormPermisos.get('duration').setValue(this.duracion);
      } else {
        this.message.Error("Error", this.messagErrorDate);
        this.duracion = null;
        this.FormPermisos.get('duration').setValue(null);
      }
    }
  }

  saveForm(form: Permissions) {
    this.fechaLabel = this.functionEter.dateForm(form.date)
    this.descripcionLabel = form.description
    if (form.remuneration == 1) {
      this.remuneracionLabel = 'SI'
    } else {
      this.remuneracionLabel = 'NO'
    }
  }

  errorMessage() {
    let msg = 'Complete los campos'
    if(this.duracion == null) msg = this.messagErrorDate
    this.message.Error('Error', msg)
  }
  save() {
    if (this.remuneracionLabel == 'SI') {
      this.remuneracionLabel = 1
    } else {
      this.remuneracionLabel = 0
    }

    let formPermissions: Permissions = {
      userId: this.cedula,
      date: this.fechaLabel,
      startDate: this.inicio,
      finalDate: this.final,
      duration: this.duracion,
      description: this.descripcionLabel,
      remuneration: this.remuneracionLabel,
      approvedBy: this.FormPermisos.get('approvedBy').value
    }


    this.http.postData(`${this.urlPostPermisos}`, formPermissions).subscribe(
      (res: BaseResponse<GenericResponse>) => {
        if (res['code'] === 0) {
          this.message.SuccessToast('Permiso creado correctamente')
          this.dialogRef.close()
        } else {
          this.message.Error('Error', 'Error creando Permisos')
        }
      }, err => {
        this.message.Error('Error', `${err}`)
      }
    )


  }

}
